'use strict';

customerZone.filter('capitalize', function() {
    return function(input) {
        if (!input) return input;
        input = ''+input;
        return input.charAt(0).toUpperCase() + input.substr(1);
    };
});
